import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=37d2ea50"
import script from "./calc.vue?vue&type=script&lang=js"
export * from "./calc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports